
import { useState, useEffect } from 'react'
import React from 'react'
import './index.less'
console.log(React)

export default function Popup(props) {
  const [ifon, setIfon] = useState({
    activeId: null,
    total: null,
    loading: true,
    page: 1,
    type: null,
    datas: []
  })

  useEffect(() => {
    props.rule && props.rule(ifon.page, (obj) => {
      setIfon({
        ...ifon,
        datas: obj.datas,
        total: obj.total,
        type: obj.type,
        loading: false
      })
    })
  }, [])

  return (<div className='Popup'>
    <div className='Popup_top'>
      <div className='top_titleAer'>
        <h3 className='title'>上传图片</h3>
        <i className='close' onClick={() => {
          props.close && props.close()
        }}>X</i>
      </div>
      <div className='top_ifon'>
        <div className='ifon'>
          <span className='ifon_text'>朋友圈-常规广告,共<span className='text1'>..</span>个</span>
          <span className='text1'>前往素材库</span>
        </div>
        <button className='top_button'>本地上传</button>
      </div>
    </div>

    <main className='popup_main'>
      {ifon.loading ? <div className='main_loading'><img className='loading_img' src='http://tva1.sinaimg.cn/large/006APoFYly8gz1yv2qqn6g307307348n.gif' /></div> : !ifon.loading && ifon.datas.length ? <ul className='main_ul'>
        {ifon.datas.map((item, index) => {
          return (<li key={item.id} onClick={() => {
            setIfon({
              ...ifon,
              activeId: item.id
            })
          }} className={`item ${item.id === ifon.activeId ? 'active' : ''
          }`}>
            <div className='item_top'>{ifon.type === 'img' ? <img className='img' src={item.path} /> : <video className='video' src={item.path}></video>}</div>
            <div className='item_bottom'>
              <span className='name'>{item.image_id}</span>
              <span className='tips'>{item.fileSize}</span>
            </div>
          </li>)
        })}
      </ul> : <h3 style={{ textAlign: 'center' }}>暂无数据</h3>}

    </main>

    <div className='Popup_paging'>
      <div className='paging_an'>
        <span className='an_text' onClick={() => {
          if (ifon.page > 1) {
            console.log(ifon.page)
          }
        }}>{'<<'}</span>
        <span className='an_text' onClick={() => {
          if (ifon.page > 1) {
            console.log(ifon.page)
          }
        }}>{'<'}</span>
      </div>
      <span className='paging_text'>{ifon.page}/{ifon.total && Math.ceil(ifon.total / 10)}</span>
      <div className='paging_an'>
        <span className='an_text' onClick={() => {
          const pa = Math.ceil(ifon.total / 10)
          if (ifon.page < pa) {
            console.log(ifon.page)
          }
        }}>{'>'}</span>
        <span className='an_text' onClick={() => {
          const pa = Math.ceil(ifon.total / 10)
          if (ifon.page < pa) {
            console.log(ifon.page)
          }
        }}>{'>>'}</span>
      </div>
    </div>

    <div className='paging_button'>
      <button className='button cancel' onClick={() => { props.cancel && props.cancel() }}>取消</button>
      <button className='button determine' onClick={() => {
        const s = ifon.datas.filter((item) => {
          return item.id === ifon.activeId
        })
        props.determine && props.determine(s[0])
      }}>确定</button>
    </div>
  </div>)
}
